import { render, staticRenderFns } from "./role-add-or-update.vue?vue&type=template&id=3679fe86&scoped=true&"
import script from "./role-add-or-update.vue?vue&type=script&lang=js&"
export * from "./role-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./role-add-or-update.vue?vue&type=style&index=0&id=3679fe86&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679fe86",
  null
  
)

export default component.exports